import { FormControl, FormHelperText, makeStyles } from '@material-ui/core'
import { useField } from 'formik'
import React from 'react'

import { Typography } from 'src/modules/ui'

import FormikCheckbox from './FormikCheckbox'

const useStyles = makeStyles(theme => ({
  label: {
    paddingRight: theme.spacing(4),
  },
}))

export const FormikCheckboxGroup = ({
  fullWidth,
  margin,
  name,
  options,
  label,
  ...props
}) => {
  const classes = useStyles()
  const [, fieldGroupMeta] = useField({ name, type: 'checkbox' })
  const { touched, error } = fieldGroupMeta
  const hasError = Boolean(touched && error)

  return (
    <>
      <FormControl fullWidth={fullWidth} margin={margin}>
        {label && <Typography className={classes.label}>{label}</Typography>}
        {options.map(({ value, label }, idx) => (
          <FormikCheckbox
            fullWidth={fullWidth}
            key={idx}
            label={label}
            name={name}
            value={String(value)}
          />
        ))}
      </FormControl>
      {hasError && <FormHelperText error>{error}</FormHelperText>}
    </>
  )
}

export default FormikCheckboxGroup
